import { User } from '@Types/index';
import { Balance } from '@Types/api/form/leaveRequest/Balance';

import { ViewResolver } from '@Components/ViewResolver';
import DekstopLayout from './desktop/DesktopLayout';
import MobileLayout from './mobile/MobileLayout';

interface InformationSidebarProps {
  userInfo: User;
  selectedUser?: User;
  showMRsection?: boolean;
  showSelectEmployee?: boolean;
  showLeaveBalance?: boolean;
  showExtraUserFields?: boolean;
  balance?: Balance;
  requestHeaderStep?: boolean;
  handleSearchEmpByNumber?: (empNumber?: string) => void;
  handleApplySelectedUser?: () => void;
}

const InformationSidebar: React.FC<InformationSidebarProps> = (props) => {
  return (
    <ViewResolver
      desktop={<DekstopLayout {...props} />}
      mobile={<MobileLayout {...props} />}
    />
  );
};

export default InformationSidebar;
